import React from 'react';
import { Autocomplete, Box, Chip, TextField, Typography } from '@mui/material';
import i18n from '../../i18';
import { CloseCircleCustomLinearIcon } from '../../icons-lib';
import { normalizeTagsValue } from '../../utils/formatValue';

const tagPattern = /^[a-zA-Z0-9][a-zA-Z0-9\s-_]{1,29}$/;

export default class DialogTagsField extends React.Component {
    constructor(props) {
        super(props);
        let initialTags = [];
        try {
            initialTags = normalizeTagsValue(props.value);
        } catch (e) {
            initialTags = [];
        }
        this.state = {
            tags: initialTags,
            inputValue: '',
            highlightedTag: null
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data.id !== this.props.data.id) {
            let initialTags = [];
            try {
                initialTags = normalizeTagsValue(this.props.value);
            } catch (e) {
                initialTags = [];
            }
            this.setState({
                tags: initialTags,
                inputValue: '',
                highlightedTag: null
            });
        }
    }

    validateInputValue = (inputValue) => {
        return tagPattern.test(inputValue);
    };

    handleKeyDown = (event) => {
        const { inputValue, tags } = this.state;

        const trimmedValue = inputValue.trim();

        if (
            (event.key === 'Enter' || event.key === ',') &&
            trimmedValue !== ''
        ) {
            event.preventDefault();

            if (!this.validateInputValue(trimmedValue)) {
                this.setState({ inputValue: '' });
                return;
            }

            if (tags.includes(trimmedValue)) {
                this.setState({ highlightedTag: trimmedValue, inputValue: '' });

                setTimeout(() => this.setState({ highlightedTag: null }), 600);
            } else {
                const newTags = [...tags, trimmedValue];
                this.setState({ tags: newTags, inputValue: '' });

                this.props.onChange(
                    this.props.field.id,
                    newTags.length > 0 ? newTags.join() : ''
                );
            }
        }
    };

    handleDelete = (tagToDelete) => {
        const updatedTags = this.state.tags.filter(
            (tag) => tag !== tagToDelete
        );
        this.setState({ tags: updatedTags });

        const stringifiedTags =
            updatedTags.length > 0 ? updatedTags.join() : '';

        this.props.onChange(this.props.field.id, stringifiedTags);
    };

    handleInputChange = (event, newInputValue) => {
        this.setState({ inputValue: newInputValue });
    };

    render() {
        const { field } = this.props;
        const { tags, inputValue, highlightedTag } = this.state;

        const translatedLabel = i18n.t(`columns.${field.label}`);
        const placeholderLabel = i18n.t(`placeholder.${field.label}`);
        const required = field.required;
        const requiredLabel = required ? ' *' : '';

        return (
            <Box mb={2}>
                <Typography variant="subtitle2" mb={1}>
                    {translatedLabel + requiredLabel}
                </Typography>

                <Autocomplete
                    multiple
                    freeSolo
                    clearIcon={null}
                    options={[]}
                    value={tags}
                    inputValue={inputValue}
                    onInputChange={this.handleInputChange}
                    renderTags={(value, getTagProps) =>
                        value.map((tag, index) => (
                            <Chip
                                size="small"
                                key={index}
                                label={tag}
                                {...getTagProps({ index })}
                                deleteIcon={
                                    <CloseCircleCustomLinearIcon
                                        sx={{ width: '12px', height: '12px' }}
                                    />
                                }
                                onDelete={() => this.handleDelete(tag)}
                                sx={{
                                    transform:
                                        highlightedTag === tag
                                            ? 'scale(1.1)'
                                            : 'scale(1)',
                                    transition: 'transform 0.2s'
                                }}
                            />
                        ))
                    }
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            placeholder={
                                tags.length === 0 ? placeholderLabel : ''
                            }
                            onKeyDown={this.handleKeyDown}
                            sx={{
                                '& .MuiAutocomplete-input': { fontSize: '16px' }
                            }}
                        />
                    )}
                />
            </Box>
        );
    }
}
